import React from "react";

export default function NavBarButtonGroup() {
  return (
    <>
      <div className="auth-buttons">
        <button className="btn btn-primary">sign in</button>
        <button className="btn btn-outline">sign up</button>
      </div>
    </>
  );
}
